import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

const temp = {
    contractRenewalDate: "2026-01-01",
    contractType: "Annual",
};

export const useGetContractsSummary = (studentId) => {
    const {
        isLoading, data: contractsSummary, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: [`student/${studentId}/Contracts/Summary`],
        queryFn: () => axiosManager.get$(`/parent/api/students/${studentId}/Contracts/Summary`).then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        keepPreviousData: true,
        enabled: !!studentId,
    });

    return {
        isLoading,
        isRefetching,
        contractsSummary: contractsSummary || temp,
        error,
        refetch,
    };
};
